import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Container, Row, Col, Modal} from "react-bootstrap";
import {Img} from "../Img";
import CloseButton from "../CloseButton";
import SimpleBar from "simplebar-react";
import {black, bold, darkBlue, regular, text} from "../../styles/globalStyleVars";
import {Swiper, SwiperSlide} from 'swiper/react';
import swiper, {Autoplay, Navigation, Pagination, EffectFade} from "swiper";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import ReactHtmlParser from "react-html-parser";


const MyComponent = ({data}) => {

    const [show, setShow] = useState(false);
    const [popupData, setPopupData] = useState('');
    const handleClose = () => setShow(false);
    const handleShow = (i) => {
        setShow(true);
        setPopupData(i)
    }

    return (
        <StyledComponent className={'associate pb-200'}>
            <Container>
                <Row>
                    {
                        data && data?.length>0 &&
                        data?.map((element)=>{
                            return(
                                <Col onClick={() => handleShow(element)}  md={4} sm={4}>
                                    <div className="associate__single">
                                        <div className="associate__single__img">
                                            <Img src={element?.single?.thumb}/>
                                        </div>
                                        <div className="associate__single__content">
                                            {element?.single?.meta_data && <p className={'split-up'}>{element?.single?.meta_data}</p>}
                                            {element?.post_title && <h6 className={'split-up'}>{element?.post_title}</h6>}
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </Row>
            </Container>

            <Modal className={'founder-modal associate-modal'} show={show} onHide={handleClose}>
                <div onClick={handleClose}>
                    <CloseButton/>
                </div>

                <Container>
                    <Row>
                        <Col md={4}>
                            <div className="founder-modal__img">
                                <Img src={popupData?.single?.thumb}/>
                            </div>
                            <div className="founder-modal__add">

                                <p>{popupData?.single?.meta_data}</p>
                                <h6>{popupData?.post_title}</h6>
                            </div>
                        </Col>
                        <Col md={{span: 7, offset: 1}}>
                            {

                                <SimpleBar style={
                                    {maxHeight: window.innerHeight - 200 + 'px',paddingRight: '20px'}
                                }>
                                    {
                                        popupData?.text1?.desc &&
                                        <>{ReactHtmlParser(popupData?.text1?.desc)}</>
                                    }
                                    {
                                        popupData?.table?.desc &&
                                        <div className={'table-responsive'}>
                                            <table className={'table'}>

                                                <tbody>
                                                {/*<tr>*/}
                                                {/*    <th>[Table Title] Indicator</th>*/}
                                                {/*    <th>[Table Title] Description</th>*/}

                                                {/*</tr>*/}
                                                {ReactHtmlParser(popupData?.table?.desc)}

                                                {/*<tr>*/}
                                                {/*    <td>Stock Market Indices</td>*/}
                                                {/*    <td>: Performance of major stock market indices</td>*/}

                                                {/*</tr>*/}
                                                {/*<tr>*/}
                                                {/*    <td>Stock Market Indices</td>*/}
                                                {/*    <td>: Performance of major stock market indices</td>*/}

                                                {/*</tr>*/}
                                                {/*<tr>*/}
                                                {/*    <td>Stock Market Indices</td>*/}
                                                {/*    <td>: Stock Market Indices</td>*/}

                                                {/*</tr>*/}

                                                </tbody>
                                            </table>

                                        </div>
                                    }

                                    {
                                        popupData?.gallery?.list && popupData?.gallery?.list?.length>0 ?
                                            <Swiper
                                                Swiper modules={[Autoplay, Pagination, Navigation, EffectFade]}
                                                slidesPerView={1}
                                                speed={1500}
                                                spaceBetween={50}
                                                draggable={true}
                                                navigation={{
                                                    prevEl: '#details-prev',
                                                    nextEl: '#details-next',
                                                }}
                                                loop={true}
                                            >
                                                {
                                                    popupData?.gallery?.list && popupData?.gallery?.list?.length>0 &&
                                                    popupData?.gallery?.list?.map((element,index)=>{
                                                        return(
                                                            <SwiperSlide key={index}>
                                                                <div className="img-group-caption">
                                                                    <div className="img-wrapper-big">
                                                                        <Img src={element?.image}/>
                                                                    </div>
                                                                    {element?.title && <p className={'split-up'}>{element?.title}</p>}

                                                                </div>
                                                            </SwiperSlide>
                                                        )
                                                    })
                                                }

                                            </Swiper> : ''
                                    }


                                    {/*next prev navigation*/}
                                    <div className="navigation">
                                        <Container>
                                            <Row>
                                                <Col>
                                                    <ul>
                                                        <li id={'details-prev'}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                                                                 viewBox="0 0 44 44">
                                                                <g id="Next" transform="translate(16429 -2014)">
                                                                    <g id="Rectangle_492" data-name="Rectangle 492"
                                                                       transform="translate(-16429 2014)" fill="none" stroke="#fff"
                                                                       stroke-width="1" opacity="0.5">
                                                                        <rect width="44" height="44" rx="22" stroke="none"/>
                                                                        <rect x="0.5" y="0.5" width="43" height="43" rx="21.5"
                                                                              fill="none"/>
                                                                    </g>
                                                                    <g id="Group_4824" data-name="Group 4824"
                                                                       transform="translate(-17065.5 434.5)">
                                                                        <g id="Group_4823" data-name="Group 4823"
                                                                           transform="translate(11 4)">
                                                                            <line id="Line_9" data-name="Line 9" x2="5" y2="5"
                                                                                  transform="translate(647.5 1592.5)" fill="none"
                                                                                  stroke="#fff"
                                                                                  strokeLinecap="round" stroke-width="1"/>
                                                                            <line id="Line_10" data-name="Line 10" x1="5" y2="5"
                                                                                  transform="translate(647.5 1597.5)" fill="none"
                                                                                  stroke="#fff"
                                                                                  strokeLinecap="round" stroke-width="1"/>
                                                                        </g>
                                                                        <line id="Line_11" data-name="Line 11" x2="10"
                                                                              transform="translate(653.5 1601.5)" fill="none"
                                                                              stroke="#fff"
                                                                              strokeLinecap="round" stroke-width="1"/>
                                                                    </g>
                                                                    <g id="Rectangle_5661" data-name="Rectangle 5661"
                                                                       transform="translate(-16429 2058) rotate(-90)" fill="none"
                                                                       stroke="#fff"
                                                                       stroke-width="1" strokeDasharray="0" opacity="0">
                                                                        <rect width="44" height="44" rx="22" stroke="none"/>
                                                                        <rect x="0.5" y="0.5" width="43" height="43" rx="21.5"
                                                                              fill="none"/>
                                                                    </g>
                                                                </g>
                                                            </svg>

                                                        </li>
                                                        <li id={'details-next'}>
                                                            <svg id="Prev" xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                                                                 viewBox="0 0 44 44">
                                                                <g id="Rectangle_492" data-name="Rectangle 492" fill="none"
                                                                   stroke="#fff"
                                                                   stroke-width="1" opacity="0.5">
                                                                    <rect width="44" height="44" rx="22" stroke="none"/>
                                                                    <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="none"/>
                                                                </g>
                                                                <g id="Group_4824" data-name="Group 4824" transform="translate(17 17)">
                                                                    <g id="Group_4823" data-name="Group 4823">
                                                                        <line id="Line_9" data-name="Line 9" x1="5" y2="5" fill="none"
                                                                              stroke="#fff" strokeLinecap="round" stroke-width="1"/>
                                                                        <line id="Line_10" data-name="Line 10" x2="5" y2="5"
                                                                              transform="translate(0 5)" fill="none" stroke="#fff"
                                                                              strokeLinecap="round" stroke-width="1"/>
                                                                    </g>
                                                                    <line id="Line_11" data-name="Line 11" x1="10"
                                                                          transform="translate(0 5)"
                                                                          fill="none" stroke="#fff" strokeLinecap="round"
                                                                          stroke-width="1"/>
                                                                </g>
                                                                <g id="Rectangle_5661" data-name="Rectangle 5661"
                                                                   transform="translate(0 44) rotate(-90)" fill="none" stroke="#fff"
                                                                   stroke-width="1" strokeDasharray="1 140" opacity="0">
                                                                    <rect width="44" height="44" rx="22" stroke="none"/>
                                                                    <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="none"/>
                                                                </g>
                                                            </svg>


                                                        </li>
                                                    </ul>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                    {ReactHtmlParser(popupData?.text2?.desc)}
                                    <div className={'images'}>
                                        {
                                            popupData?.images?.top?
                                                <div className={'images__big'}>
                                                    <Img src={popupData?.images?.top}/>
                                                </div> : ''
                                        }

                                        <div className="image-gallery-slider">


                                        </div>
                                        <Row className={'images__small'}>
                                            <Col md={6}>
                                                <img src={popupData?.images?.left}/>
                                            </Col>
                                            <Col md={6}>
                                                <img src={popupData?.images?.right}/>
                                            </Col>
                                        </Row>

                                    </div>

                                </SimpleBar>



                                // <>
                                //     {ReactHtmlParser(popupData?.text1?.desc)}
                                // </>

                            }


                        </Col>
                    </Row>
                </Container>

            </Modal>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
  background-color: #F8F8F8;
  padding-top: 60px;
  table{
    tr{
      
      &:last-child{
        td{
          border-bottom: 1px solid transparent;
        }
      }
      th{
        padding-bottom: 20px;
        border-bottom: 1px solid ${black};
      }
      td{
        padding-bottom: 20px;
        padding-top: 20px;
        border-bottom: 1px solid ${text};
      }

    }
  }
  .associate__single {
    margin-bottom: 40px;
    background: #F2F2F2;


    &__img {
      padding-top:calc(280/370 *100%);
      position: relative;
      overflow: hidden;
      .global-image{
        overflow: hidden;
        img{
          transform: scale(1.01);
          transition: 1.4s ease;
        }
      }
      &:hover {
        .global-image img{
          transform: scale(1.06) !important;
        }
      }
    }

    &__content {
      cursor: pointer;
      padding: 20px;
      p{
        font-size: 12px;
        line-height: 16px;
        font-family: ${regular};
        color: ${darkBlue};
      }
      h6{
        color: ${darkBlue};
        font-family: ${bold};
      }
    }
  }

`;

export default MyComponent;
